export default __webpack_public_path__ + "static/media/servicemacha-logo.4dd4b4e4.png";